const fetchDevice = async (): Promise<string> => {
    const response = await fetch('/api/device');

    return (await getJson(response)).deviceId;
}

const sendScan = async (scan: object) => {
    const response = await fetch('/api/scan', {
        method: 'POST',
        body: JSON.stringify(scan),
    });

    return getJson(response);
}

const getPrize = async (code: string) => {
    const response = await fetch('/api/get-prize?code=' + code);
    return getJson(response);
}

const activatePrize = async (code: string, activationCode: string) => {
    const response = await fetch('/api/activate-prize', {
        method: 'POST',
        body: JSON.stringify({ code, activationCode }),
    });
    return getJson(response);
}

const getJson = async (response: Response) => {
    if (!response.ok) {
        throw new Error(`Error while fetch (url:${response.url}) error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
}

export {
    fetchDevice,
    sendScan,
    getPrize,
    activatePrize,
};
